module.exports = __webpack_public_path__ + "media/images/logos/afrotech-c965121a8bfe1285db4320a6fc413b09.png";